import styles from '@src/main/shared/ui/components/footer/Footer.module.scss';

// eslint-disable-next-line no-undef
const version = APP_VERSION;

const Footer = () => (
  <footer className={styles['layout-footer']}>
    <div className={styles['footer-content']}>
      <span className={styles['text-footer']}>© IBERIA {version}</span>
    </div>
  </footer>
);

export default Footer;
